// src/pages/income/business/IncomeBusinessDraftNew.jsx
// ✅ 경영팀 "수입데이터+기안 작성" 페이지. 실제 로직은
// pages/income/_shared/IncomeDraftNew.jsx(공통 컴포넌트)에 있고, 이 파일은 경영팀
// 전용 config(incomeBusinessDraftConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import IncomeDraftNew from "../_shared/IncomeDraftNew";
import incomeBusinessDraftConfig from "./incomeBusinessDraftConfig";

export default function IncomeBusinessDraftNew() {
  return <IncomeDraftNew config={incomeBusinessDraftConfig} />;
}
